import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { CensoredApplicantsTableDefinitionZod } from '../tables';

type Arguments = {
    loanRequestId: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetCensoredApplicant = CensoredApplicantsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetCensoredApplicant = z.infer<
    typeof schemaLoanRequestResolver_GetCensoredApplicant
>;

export type LoanRequestResolver_GetCensoredApplicant = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetCensoredApplicant
>;
